import apiClient from './AxiosHttp';

const chatService = {
    sendMessage: (payload) => apiClient.post('/chat/', payload),
};

export default chatService;